
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Goatomumbaicab() {



    const cardData =
    {
        keyword: 'Goa to Mumbai Cab',
        heading: 'S9 Travels: Goa to Mumbai Cab',
        headingDescription: 'Looking for a reliable Goa to Mumbai cab service? Whether you are ending a relaxing vacation or heading to Mumbai for work or family visits, S9 Travels provides a smooth, secure, and comfortable ride that makes your long journey stress-free.',


        top: 'Top Places to Visit in Mumbai with S9 Travels',

"topPlaces": [
    {
      "title": "Gateway of India",
      "description": "An iconic landmark of Mumbai, the Gateway of India was built in 1924 to commemorate the visit of King George V and Queen Mary. Overlooking the Arabian Sea, it is a popular tourist spot and a starting point for ferry rides to Elephanta Caves."
    },
    {
      "title": "Marine Drive",
      "description": "Also known as the 'Queen's Necklace,' Marine Drive is a picturesque 3.6 km-long boulevard along the Arabian Sea. It is a favorite spot for evening walks, enjoying the sunset, and experiencing Mumbai’s vibrant nightlife."
    },
    {
      "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
      "description": "A UNESCO World Heritage Site, CSMT is a historic railway station with stunning Victorian-Gothic architecture. Built in 1887, it is one of Mumbai’s busiest railway hubs and an architectural marvel."
    },
    {
      "title": "Elephanta Caves",
      "description": "Located on Elephanta Island, these UNESCO-listed rock-cut caves date back to the 5th-7th centuries. The caves house magnificent sculptures of Hindu deities, including the famous three-headed Shiva (Trimurti)."
    },
    {
      "title": "Bandra-Worli Sea Link",
      "description": "An engineering marvel, the Bandra-Worli Sea Link is an eight-lane cable-stayed bridge connecting the suburbs of Bandra and Worli. It offers breathtaking views of the Mumbai skyline, especially at night."
    },
    {
      "title": "Siddhivinayak Temple",
      "description": "One of Mumbai’s most revered temples, Siddhivinayak Temple is dedicated to Lord Ganesha. Thousands of devotees, including Bollywood celebrities, visit the temple to seek blessings."
    },
    {
      "title": "Juhu Beach",
      "description": "Famous for its street food and lively atmosphere, Juhu Beach is a must-visit for those looking to relax by the sea. Try popular Mumbai snacks like pav bhaji, bhel puri, and vada pav from the local vendors."
    },
    {
      "title": "Colaba Causeway",
      "description": "A paradise for shoppers, Colaba Causeway is known for its vibrant street markets, trendy boutiques, and antique stores. It’s also home to iconic cafes like Café Leopold and Café Mondegar."
    },
    {
      "title": "Haji Ali Dargah",
      "description": "Located on a small islet in the Arabian Sea, Haji Ali Dargah is a revered Sufi shrine built in the 15th century. It is a stunning example of Indo-Islamic architecture and offers a peaceful spiritual experience."
    },
    {
      "title": "Sanjay Gandhi National Park",
      "description": "A green oasis in the bustling city, Sanjay Gandhi National Park is home to diverse flora and fauna, including leopards and deer. The park also features the ancient Kanheri Caves, which date back to the 1st century BCE."
    }
],

"services": [
  {
    "name": "Goa to Mumbai Cab Service",
    "description": "Book a reliable Goa to Mumbai cab with S9 Travels. Whether traveling for business, leisure, or an event, we offer one-way and round-trip services tailored to your needs. Our professional drivers and well-maintained vehicles ensure a smooth, safe, and enjoyable journey from Goa to Mumbai."
  },
  {
    "name": "Book Goa to Mumbai Taxi",
    "description": "Booking a Goa to Mumbai taxi is easy and hassle-free with S9 Travels. Choose from one-way or round-trip services for a comfortable and safe ride. Our fleet includes well-maintained cars, and our experienced drivers ensure you have a stress-free journey every time."
  },
  {
    "name": "Affordable Goa to Mumbai Cab",
    "description": "Travel affordably from Goa to Mumbai with S9 Travels. Our budget-friendly Goa to Mumbai cab services are designed for travelers who prioritize comfort without breaking the bank. Enjoy a smooth ride, professional drivers, and competitive rates for your journey."
  },
  {
    "name": "Private Taxi for Mumbai from Goa",
    "description": "Choose a private taxi from Goa to Mumbai for a personalized travel experience. Our private taxis offer flexibility and comfort, perfect for solo travelers, families, or small groups. Enjoy a private, uninterrupted ride with experienced chauffeurs, ensuring your comfort and safety."
  },
  {
    "name": "Goa to Mumbai One-Way or Round Trip",
    "description": "S9 Travels provides flexible one-way and round-trip taxi options from Goa to Mumbai. Whether you need a quick one-way ride or a convenient round-trip, we offer tailored services that meet your schedule and travel preferences."
  },
  {
    "name": "Comfortable Taxi Ride from Goa to Mumbai",
    "description": "Experience a smooth and comfortable taxi ride from Goa to Mumbai with S9 Travels. Our experienced chauffeurs and well-maintained vehicles ensure a relaxing and enjoyable journey. Whether for business, leisure, or personal reasons, we prioritize your comfort throughout the trip."
  },
  {
    "name": "Luxury Cab for Goa to Mumbai",
    "description": "For those who prefer luxury, S9 Travels offers premium Goa to Mumbai cab services. Our luxury vehicles are equipped with high-end amenities for a comfortable, stylish, and private journey. Travel in comfort and elegance with a professional chauffeur dedicated to your satisfaction."
  },
  {
    "name": "Group Travel from Goa to Mumbai by Taxi",
    "description": "Traveling with a group? S9 Travels offers spacious taxis from Goa to Mumbai, ideal for family trips, corporate outings, or group vacations. Our vehicles are designed to accommodate larger groups comfortably, ensuring a smooth and enjoyable experience for everyone."
  },
  {
    "name": "Mumbai Sightseeing Tour from Goa by Cab",
    "description": "Explore Mumbai’s iconic attractions with a customized sightseeing tour from Goa by taxi. Visit places like Gateway of India, Marine Drive, and Elephanta Caves with a knowledgeable driver. S9 Travels ensures an informative and enjoyable sightseeing tour to make your visit memorable."
  },
  {
    "name": "Goa to Mumbai Trip by Private Taxi",
    "description": "Book a private taxi for your Goa to Mumbai trip for a personalized and stress-free experience. Whether you're traveling for business or leisure, our private taxi service offers flexibility and comfort. With professional drivers and clean, well-maintained vehicles, your journey will be smooth and relaxing."
  }
],

"tableData": [
  ["Goa to Mumbai Cab Service", "Book Goa to Mumbai Taxi"],
  ["Affordable Goa to Mumbai Cab", "Private Taxi for Mumbai from Goa"],
  ["Goa to Mumbai One-Way or Round Trip", "Comfortable Taxi Ride from Goa to Mumbai"],
  ["Luxury Cab for Goa to Mumbai", "Group Travel from Goa to Mumbai by Taxi"],
  ["Mumbai Sightseeing Tour from Goa by Cab", "Goa to Mumbai Trip by Private Taxi"],
  ["", ""]
],






"whychoose": [
  {
    "WhyChooseheading": "Comfortable and Reliable Long-Distance Travel",
    "WhyChoosedescription": "S9 Travels offers a comfortable Goa to Mumbai cab service, perfect for long-distance journeys. Our fleet of well-maintained vehicles, including the Toyota Innova, ensures a smooth, comfortable ride with ample space, air conditioning, and plush seating, making your trip enjoyable no matter the distance."
  },
  {
    "WhyChooseheading": "Timely and Dependable Service",
    "WhyChoosedescription": "We understand that timely travel is essential. Our Goa to Mumbai cab service ensures punctual pick-ups and drop-offs, so you can reach your destination on time without any delays. Whether you're traveling for business, leisure, or a special event, we guarantee reliable service every time."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our experienced drivers are familiar with the best routes and road conditions for trips from Goa to Mumbai. They prioritize safety, comfort, and efficiency, ensuring your journey is smooth and pleasant, no matter the destination."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "S9 Travels offers affordable rates for the Goa to Mumbai cab service. We provide a transparent pricing structure with no hidden charges. You’ll receive a clear breakdown of the cost during the booking process, allowing you to plan your travel budget without surprises."
  },
  {
    "WhyChooseheading": "Safety and Comfort on Your Mumbai Journey",
    "WhyChoosedescription": "Your safety is our top priority. All our vehicles are equipped with modern safety features like GPS tracking, airbags, and seat belts to ensure a safe and comfortable journey for you and your passengers throughout your trip from Goa to Mumbai."
  },
  {
    "WhyChooseheading": "24/7 Availability for Flexible Scheduling",
    "WhyChoosedescription": "S9 Travels operates 24/7, offering flexible scheduling for your Goa to Mumbai trip. Whether you need an early morning departure or a late-night return, we’re here to provide reliable service that fits your travel schedule."
  },
  {
    "WhyChooseheading": "Customizable Itineraries for Your Mumbai Trip",
    "WhyChoosedescription": "We understand that every trip is unique. Whether you need to make stops along the way, have specific locations to visit, or require special arrangements, we offer customizable itineraries to suit your preferences and make your Goa to Mumbai journey even more enjoyable."
  },
  {
    "WhyChooseheading": "Simple and Hassle-Free Booking",
    "WhyChoosedescription": "Booking your Goa to Mumbai cab with S9 Travels is simple and hassle-free. You can easily book your ride online through our website or mobile app, or contact our customer service team for personalized assistance. We strive to make your booking process quick, easy, and convenient."
  }
]



















    }


    const faqData = [
        [
          {
            question: 'How can I book a cab from Goa to Mumbai with S9 Travels?',
            answer: 'Booking a cab from Goa to Mumbai is easy! You can book your ride through our website, mobile app, or by contacting our customer service team for personalized assistance. We ensure a comfortable and hassle-free journey to Mumbai.',
          },
          {
            question: 'What types of vehicles are available for a trip from Goa to Mumbai?',
            answer: 'We offer a variety of vehicles for your trip from Goa to Mumbai, including sedans, SUVs, and premium vehicles like the Toyota Innova. Choose the one that best suits your needs based on your group size and preferences.',
          },
          {
            question: 'Are the drivers experienced for the Goa to Mumbai trip?',
            answer: 'Yes, our drivers are highly experienced and familiar with the best routes for the Goa to Mumbai journey. They prioritize your safety, comfort, and a smooth travel experience.',
          },
          {
            question: 'Can I book a round-trip cab from Goa to Mumbai?',
            answer: 'Yes, you can book a round-trip cab for your journey from Goa to Mumbai. Simply provide us with your return details, and we will ensure a smooth return journey.',
          },
          {
            question: 'How long in advance should I book a cab for Goa to Mumbai?',
            answer: 'It is recommended to book your cab at least 1-2 days in advance to secure vehicle availability. However, last-minute bookings are also possible based on availability.',
          },
          {
            question: 'Is there a fixed fare for the Goa to Mumbai cab service?',
            answer: 'The fare for the Goa to Mumbai trip depends on the distance, vehicle type, and other specific requirements. Contact us for a personalized quote with transparent pricing based on your trip details.',
          },
          {
            question: 'Do you offer pick-up services from Goa airport or hotels for the Mumbai trip?',
            answer: 'Yes, we offer convenient pick-up services from Goa airport or hotels. Our professional drivers will ensure smooth transfer to your cab for a comfortable journey to Mumbai.',
          },
          {
            question: 'Can I request additional stops along the way during my trip to Mumbai?',
            answer: 'Yes, we can customize your itinerary by adding stops for meals, sightseeing, or other breaks during your journey to Mumbai. Inform us at the time of booking to include your preferred stops.',
          },
          {
            question: 'Is there any extra charge for waiting or detours during the Goa to Mumbai trip?',
            answer: 'Any additional charges for waiting time or detours will be communicated to you upfront during the booking process. We maintain full transparency in our pricing.',
          },
          {
            question: 'Why should I choose S9 Travels for my Goa to Mumbai trip?',
            answer: 'S9 Travels offers reliable, safe, and comfortable cab services for your journey from Goa to Mumbai. With well-maintained vehicles, experienced drivers, and excellent customer service, we ensure a smooth and enjoyable trip.',
          },
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Raghav Joshi',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“I booked a cab from Goa to Mumbai with S9 Travels, and the experience was fantastic. The driver was courteous and professional, and the vehicle was clean and comfortable. The journey was smooth, and we arrived in Mumbai on time. I highly recommend their services for long-distance trips!”',
        },
        {
          name: 'Mrs. Shweta Kapoor',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“Our trip from Goa to Mumbai with S9 Travels was wonderful. The vehicle was spacious and well-maintained, and the driver was skilled and friendly. We enjoyed the scenic route, and the entire trip was very comfortable. We will definitely use S9 Travels again for future travels!”',
        },
      ];
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   

      
// const productSchema = {
//   "@context": "https://schema.org",
//   "@type": "Product",
//   "name": "Goa to Mumbai Cabs",
//   "image": "https://www.s9travels.com/images/keyword/66.jpg",
//   "description": "Book trusted Goa to Mumbai cabs with S9 Travels. Enjoy affordable pricing, professional drivers, and a choice of vehicles including hatchbacks, sedans, SUVs, and luxury cars. Ideal for one-way travel, round trips, airport transfers, or scenic road journeys from Goa to Mumbai with maximum comfort and safety.",
//   "brand": {
//     "@type": "Brand",
//     "name": "S9 Travels"
//   },
//   "aggregateRating": {
//     "@type": "AggregateRating",
//     "bestRating": "5",
//     "worstRating": "1",
//     "ratingValue": "4.8",
//     "ratingCount": "8569"
//   },
//   "offers": {
//     "@type": "Offer",
//     "priceCurrency": "INR",
//     "price": "5999",
//     "availability": "https://schema.org/InStock",
//     "url": "https://www.s9travels.com/Goa-to-Mumbai-cab"
//   }
// };

      
    const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Goa to Mumbai Cab Service – S9 Travels",
  "image": "https://www.s9travels.com/images/keyword/66.jpg",
  "description": "Book premium Goa to Mumbai cab services with S9 Travels. Choose from hatchbacks, sedans, SUVs, and luxury cars at affordable fares. Enjoy safe one-way trips, round journeys, airport transfers, and scenic rides with experienced drivers.",
  "brand": {
    "@type": "Brand",
    "name": "S9 Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "7214"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4999",
    "availability": "https://schema.org/InStock",
    "url": "https://www.s9travels.com/Goa-to-Mumbai-cab"
  }
};


 


    return (
        <div>
       

        {/* <Helmet>
  <title>Goa to Mumbai Cabs | S9 Travels</title>
  <meta 
    name="description" 
    content="Book Goa to Mumbai cabs online with S9 Travels. Get reliable one-way or round-trip taxi service at affordable fares. Choose from AC sedans, SUVs, or luxury cabs with experienced drivers for a smooth and scenic ride from Goa to Mumbai." 
  />
  <meta 
    name="keywords" 
    content="Goa to Mumbai Cabs, Goa to Mumbai Taxi, Cab from Goa to Mumbai, One Way Goa to Mumbai Cab, Round Trip Goa to Mumbai Taxi, Goa to Mumbai Car Hire, Private Cab Goa to Mumbai, S9 Travels Goa to Mumbai" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet> 

// by this code showinh 5:4

*/}


      
      <Helmet>
  <title>Goa to Mumbai Cabs | Affordable Taxi & Cab Booking | S9 Travels</title>
  <meta 
    name="description" 
    content="Book trusted Goa to Mumbai cabs online with S9 Travels. Get one-way or round-trip taxi at affordable fares. Choose AC Sedans, SUVs, or luxury cabs with professional drivers for safe, comfortable, and on-time travel from Goa to Mumbai." 
  />
  <meta 
    name="keywords" 
    content="Goa to Mumbai Cabs, Goa to Mumbai Taxi, One Way Goa to Mumbai Cab, Round Trip Goa to Mumbai Taxi, Cab from Goa to Mumbai, Goa to Mumbai Car Hire, Airport Taxi Goa to Mumbai, Private Cab Goa to Mumbai, Luxury Cabs Goa to Mumbai, Affordable Goa to Mumbai Cab" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      
      
<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/66.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Goatomumbaicab;